<template>
  <Page_Tabs :tabs="tabs" no-border class="px-6 pt-4" />
</template>

<script>
import { mapGetters } from 'vuex';
import { FEATURES } from '@/constants/features';
import { canAccessFeature } from '@/utils/access';
import Page_Tabs from '@/components/widgetcomponents/Page_Tabs.vue';

export default {
  name: 'EngageWorkspaceTabs',
  components: {
    Page_Tabs,
  },
  computed: {
    ...mapGetters('auth', ['current_user']),
    tabs() {
      const tabs = [];

      if (canAccessFeature(FEATURES.MODULE_ENGAGE)) {
        tabs.push({ label: 'Engage', to: '/engage' });
      }

      if (
        this.current_user?.is_superuser &&
        canAccessFeature(FEATURES.MODULE_ENGAGE)
      ) {
        tabs.push({ label: 'Transform', to: '/transform' });
      }

      if (canAccessFeature(FEATURES.MODULE_MANAGE)) {
        tabs.push({ label: 'Manage', to: '/manage' });
      }

      return tabs;
    },
  },
};
</script>
